// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SwitchCardContract = contract({
  name: "SwitchCard",
  description: "A prominent on/off setting presented as a whole selectable card. The whole card is the switch, so the toggled state lives on the card surface. Standalone. For a row of compact settings (label left, small Switch right) use Field layout=\"setting\" instead — SwitchCard is for the heavier, card-sized toggle.",
  import: "@gradeui/ui",
  aliases: ["switch card","toggle card","setting card","feature toggle card"],
  composesWith: ["Badge (in aside)","Stack (stacking several)"],
  props: {
  "checked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "standard switch state",
  },
  "defaultChecked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "standard switch state",
  },
  "onCheckedChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "standard switch state",
  },
  "label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "title line",
  },
  "description": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "secondary line",
  },
  "aside": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot before the indicator (a Badge, price, hint)",
  },
  "hideIndicator": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the switch glyph; state shown by the card border + background",
  },
  "indicatorPosition": {
      schema: z.enum(["leading", "trailing"]).optional(),
      design: "knob",
      description: "default trailing",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "arbitrary static content instead of label/description",
  },
  },
});
